/**
 * A QR code drawn as SVG (uqr, MIT): dark modules in `ink-deep` on `qr-paper`, the same in both themes so every
 * phone camera reads it, with the standard four-module quiet zone.
 */
import type { ReactElement } from 'react';
import { encode } from 'uqr';

export function QrCode({ text, label }: { readonly text: string; readonly label: string }): ReactElement {
  const qr = encode(text, { ecc: 'M', border: 4 });
  let d = '';
  qr.data.forEach((row, y) =>
    row.forEach((dark, x) => {
      if (dark) d += `M${x} ${y}h1v1h-1z`;
    }),
  );
  return (
    <svg
      className="qr-code"
      role="img"
      aria-label={label}
      viewBox={`0 0 ${qr.size} ${qr.size}`}
      shapeRendering="crispEdges"
      data-text={text}
    >
      <rect className="qr-code__paper" width={qr.size} height={qr.size} />
      <path className="qr-code__ink" d={d} />
    </svg>
  );
}
